<template>
  <v-container>
    <v-card>
      <v-card-title>Trades</v-card-title>
      <div>
        <v-progress-linear v-if="loading" indeterminate color="primary" />
        <div v-else>
          <CreateTradeForm />
          <ManageTradeForm />
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import CreateTradeForm from '../../components/trades/CreateTradeForm.vue';
import ManageTradeForm from '../../components/trades/ManageTradeForm.vue';
export default {
  components: {
    CreateTradeForm,
    ManageTradeForm
  },
  beforeRouteEnter(to, from, next) {
    next(async (vm) => {
      console.log('beforeRouteEnter in trades page');
      await vm.fetchData();
    });
  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate in trades page');
    this.loading = true;
    this.fetchData();
    next();
  },
  data() {
    return {
      loading: true,
      page: 1,
      itemsPerPage: 10,
      totalPositions: 0
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalPositions / this.itemsPerPage);
    }
  },
  mounted() {
    console.log('mounted in trades page');
    this.loading = true;
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;
        await Promise.all([
          this.$store.dispatch('trades/getActiveTradeList'),
          this.$store.dispatch('trades/getAllPositionsWithoutStrategy')
        ]);
      } catch (error) {
        console.error('Error fetching trades:', error);
      } finally {
        this.loading = false;
      }
    },

    saveData(data) {
      this.$store.dispatch('trades/createTrade', data);
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
